import React, { type ComponentPropsWithoutRef, type ComponentRef, forwardRef, type ReactNode } from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { BaseDropdownItemUI } from '../base/BaseDropdownItemUI';
export const SelectItem = forwardRef<ComponentRef<typeof SelectPrimitive.Item>, ComponentPropsWithoutRef<typeof SelectPrimitive.Item> & {
  checked: boolean;
  label: ReactNode;
  invalid?: boolean;
  leftSlot?: React.JSX.Element;
  rightSlot?: React.JSX.Element;
}>(({
  className,
  label,
  checked,
  invalid,
  leftSlot,
  rightSlot,
  ...props
}, ref) => {
  return <SelectPrimitive.Item asChild {...props}>
        <BaseDropdownItemUI ref={ref} checked={checked} disabled={props.disabled || false} invalid={invalid || false} className={className}>
          {leftSlot}
          <div className="grow text-ellipsis">
            <SelectPrimitive.ItemText>{label}</SelectPrimitive.ItemText>
          </div>
          {rightSlot}
        </BaseDropdownItemUI>
      </SelectPrimitive.Item>;
});
SelectItem.displayName = SelectPrimitive.Item.displayName;